import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Container, Grid, Typography } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      width: "100%"
    },
    containerPads: {
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(6)
    },
    img: {
      width: "100%"
    },
    itemsContent: _defineProperty({
      justifyContent: "flex-end"
    }, theme.breakpoints.down("sm"), {
      justifyContent: "center",
      marginTop: theme.spacing(6)
    }),
    greenHighlightedTitle: {
      background: "linear-gradient(bottom, ".concat(theme.palette.primary[100], " 60%, transparent 40%)"),
      display: "inline",
      height: theme.spacing(4.5)
    }
  };
});
var TextGridImage = function TextGridImage(_ref) {
  var bgColor = _ref.bgColor,
    title = _ref.title,
    description = _ref.description,
    images = _ref.images,
    titleStyle = _ref.titleStyle;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    className: classes.wrapper
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    className: classes.containerPads
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React__default.createElement(Box, {
    textAlign: titleStyle !== null && titleStyle !== void 0 && titleStyle.textAlignment ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.textAlignment.toLowerCase() : "center",
    mt: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle !== null && titleStyle !== void 0 && titleStyle.headingVariant ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingVariant : "h2",
    className: (titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingStyle) === "Green highlighted" ? classes.greenHighlightedTitle : ""
  }, title)), /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    component: "div"
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
    markdownString: description
  }))))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row",
    className: classes.itemsContent
  }, images === null || images === void 0 ? void 0 : images.map(function (image, index) {
    var _image$image, _image$image2;
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      key: index
    }, (image === null || image === void 0 || (_image$image = image.image) === null || _image$image === void 0 ? void 0 : _image$image.url) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      alt: "featured image-".concat(index),
      className: classes.img,
      src: retrieveContentfulImage(image === null || image === void 0 || (_image$image2 = image.image) === null || _image$image2 === void 0 ? void 0 : _image$image2.url, {
        width: 250
      })
    }));
  }))))));
};
TextGridImage.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  description: PropTypes__default.string,
  images: PropTypes__default.array,
  titleStyle: PropTypes__default.shape({
    textAlignment: PropTypes__default.string,
    headingVariant: PropTypes__default.string,
    headingStyle: PropTypes__default.string
  })
};

export { TextGridImage as default };
//# sourceMappingURL=TextGridImage.js.map
